import { SearchDashboard, VpayTransactionRes } from '@/models/vpaytransactions.model'
import { VEClient } from '@/utils/axios'

export const postDashboard = async (data: SearchDashboard): Promise<VpayTransactionRes> => {
  const response = await VEClient.post(`/api/vpay/dashboard`, data)
  return response.data
}